import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SideNavService {
  private sideNavSubject = new BehaviorSubject<string | null>(null);
  private sideNavTreeSubject = new BehaviorSubject<string | null>(null);

  setTreeNode(node: string): void {
    this.sideNavSubject.next(node);
  }

  getTreeNode(): Observable<string | null> {
    return this.sideNavSubject.asObservable();
  }

  setTree(tree: any) {
    this.sideNavTreeSubject.next(tree);
  }

  onTreeChange() {
    return this.sideNavTreeSubject.asObservable();
  }

  highlightNode(displayName: string) {
    let list = document.getElementsByClassName('circle-number');
    Array.from(list).forEach((elem: any) => {
      if(displayName.toLowerCase() === elem?.nextElementSibling?.innerText?.toLowerCase()) {
        elem.classList?.add('selected');
      } else {
        elem.classList?.remove('selected');
      }
    });
  }
}
